import Breadcrumb from "@/components/base/Breadcrumb";
import ContactForm from "@/pages/about/components/ContactForm";
import { allMedia, movieList, tvList } from "@/lib/media";
import { newsList } from "@/mocks/news";
import { specials } from "@/mocks/specials";
import { usePageMeta } from "@/hooks/usePageMeta";

const features = [
  {
    icon: "ri-film-line",
    title: "影视内容聚合",
    desc: "汇集电影与电视剧的封面、简介、主创与类型信息，一处浏览，快速了解。",
  },
  {
    icon: "ri-filter-3-line",
    title: "分类筛选与搜索",
    desc: "支持按类型、年份、地区、集数自由筛选，也可通过关键词快速检索作品与资讯。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "主题专题策划",
    desc: "围绕题材与情绪精心策划观影专题，附编辑推荐理由，帮你按兴趣发现好内容。",
  },
  {
    icon: "ri-newspaper-line",
    title: "影视资讯动态",
    desc: "关注档期前瞻、行业观察与口碑盘点，及时了解影视圈的最新动态。",
  },
];

export default function About() {
  usePageMeta({
    title: "关于我们-555电影网",
    description:
      "了解555电影网的网站定位、内容特色与联系方式。本站为影视资讯与内容介绍平台，不提供真实视频播放与下载服务。",
    keywords: "关于我们,555电影网,联系方式,版权声明",
  });

  return (
    <div className="mx-auto max-w-page px-4 py-6 md:px-6 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <section className="mt-4 overflow-hidden rounded-xl bg-primary-800 px-6 py-10 md:px-10 md:py-14">
        <div className="max-w-3xl">
          <h1 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            关于 555 电影网
          </h1>
          <p className="mt-4 leading-relaxed text-primary-100 md:text-base">
            555电影网是一个专注于提供最新电影和电视剧在线观看与资讯的影视娱乐平台。
            我们的目标是为广大观众与影视爱好者提供丰富且及时的影视资讯、内容介绍与精选推荐，
            帮助用户方便快捷地发现并选择感兴趣的影视作品。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4 sm:max-w-lg">
            <div className="rounded-lg bg-primary-900/60 px-3 py-4 text-center">
              <p className="font-heading text-2xl font-bold text-accent-400">
                {allMedia.length}
              </p>
              <p className="mt-1 text-xs text-primary-200">影视收录</p>
            </div>
            <div className="rounded-lg bg-primary-900/60 px-3 py-4 text-center">
              <p className="font-heading text-2xl font-bold text-accent-400">
                {newsList.length}
              </p>
              <p className="mt-1 text-xs text-primary-200">资讯文章</p>
            </div>
            <div className="rounded-lg bg-primary-900/60 px-3 py-4 text-center">
              <p className="font-heading text-2xl font-bold text-accent-400">
                {specials.length}
              </p>
              <p className="mt-1 text-xs text-primary-200">主题专题</p>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-10">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl font-bold text-foreground-900">我们提供什么</h2>
        </div>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.1fr]">
        <div className="space-y-6">
          <section className="rounded-lg border border-background-200 bg-background-50 p-6">
            <div className="flex items-center gap-2">
              <span className="h-5 w-1 rounded-full bg-secondary-500"></span>
              <h2 className="font-heading text-lg font-bold text-foreground-900">联系方式</h2>
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-secondary-600">
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <p className="text-foreground-400">邮箱</p>
                  <p className="text-foreground-800">contact@555movies.demo</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-secondary-600">
                  <i className="ri-customer-service-2-line"></i>
                </span>
                <div>
                  <p className="text-foreground-400">反馈渠道</p>
                  <p className="text-foreground-800">可通过右侧表单在线留言</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-secondary-600">
                  <i className="ri-time-line"></i>
                </span>
                <div>
                  <p className="text-foreground-400">响应时间</p>
                  <p className="text-foreground-800">工作日 24 小时内回复</p>
                </div>
              </li>
            </ul>
          </section>

          <section className="rounded-lg border border-background-200 bg-background-100 p-6">
            <div className="flex items-center gap-2">
              <span className="h-5 w-1 rounded-full bg-accent-500"></span>
              <h2 className="font-heading text-lg font-bold text-foreground-900">使用须知</h2>
            </div>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-error-warning-line mt-0.5 text-accent-500"></i>
                <span>
                  本站为影视资讯与内容介绍平台，<strong>不提供真实视频播放、下载与评论服务</strong>，
                  页面中的评分、数据均为演示用途。
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-secondary-500"></i>
                <span>收藏功能仅保存在你的本地浏览器中，不会上传至服务器。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-copyright-line mt-0.5 text-primary-500"></i>
                <span>
                  本站展示的影片名称、简介与图片均为示意内容，相关版权归原作者所有，
                  如涉侵权请联系我们处理。
                </span>
              </li>
            </ul>
          </section>
        </div>

        <ContactForm />
      </div>

      <section className="mt-10 rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="font-heading text-lg font-bold text-foreground-900">版权声明</h2>
        <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-600">
          <p>
            555电影网（以下简称"本站"）所有原创文字、版面设计及专题策划内容的著作权归本站所有。
            未经许可，任何单位或个人不得以任何形式复制、转载或用于商业用途。
          </p>
          <p>
            本站收录的影视作品信息仅用于内容介绍与推荐展示，不存储、不传播任何影视资源。
            当前版本共收录电影 {movieList.length} 部、电视剧 {tvList.length} 部，
            资讯 {newsList.length} 篇，专题 {specials.length} 个。
          </p>
          <p>
            如本站内容无意中侵犯了您的合法权益，请通过上方联系方式与我们取得联系，
            我们将在核实后第一时间处理。
          </p>
        </div>
      </section>
    </div>
  );
}